'use strict';

import * as Utils from './utils/utils.js';

export class emendo_map {

	constructor(map_id, map_zoom) {

		window.onerror  =  function (msg, url, line) {
			document.write ("Message : " + msg );
			document.write ("url : " + url );
			document.write ("Line number : " + line );
		}

		// Create global
		this.map = null;
		this.map_id = map_id;
		this.map_zoom = map_zoom || 16;
		this.map_layers = [];

		this.markers = [];
		this.icons = [];
		this.icons_L = [];

		// Set map layer
		this.CartoDB_Voyager = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
			maxZoom: 19
		});

		// Bind this to class functions
		this.create = this.create.bind(this);
		this.newMarker = this.newMarker.bind(this);

	}

	/* Create Map
	-------------------------------------------------------------------------------------------------- */
	create(response) {

		return new Promise((resolve, reject) => {

			// Test if element exist
			const element =  document.getElementById(this.map_id);
			if (typeof(element) == 'undefined' || element == null) {
				console.log( 'Element for map doesn\'t exist : ' + this.map_id);
				return;
			}

			// Create map
			this.map = L.map( this.map_id, {
				zoomControl: false
			}).setZoom(this.map_zoom);

			// Set zoom control position
			L.control.zoom({
				position: 'topright'
			}).addTo(this.map);

			// Add background Layer
			this.map.addLayer(this.CartoDB_Voyager);

			// Get Icons
			fetch( rest_object.map_api_url + 'icons', {
				method: "GET",
				cache: "no-cache",
				headers: { "Content-Type": "application/json; charset=utf-8"  }
			} )
			.then( response => { return response.json() } )
			.then( icons => {

				// Save icons
				this.icons = icons;

				// Create Leaflet icon objects
				for (var key in icons) {
					this.icons_L[ key ] = L.icon({
						iconUrl: 	icons[key].iconUrl,
						iconSize:     icons[key].iconSize, // size of the icon
						iconAnchor:   icons[key].iconAnchor, // point of the icon which will correspond to marker's location
						popupAnchor:  icons[key].popupAnchor // point from which the popup should open relative to the iconAnchor
					});
				}
				resolve();
			})
			.catch(err => {
				console.log(err)
				reject(err);
			});

		});
	}

	/* remove Markers
	-------------------------------------------------------------------------------------------------- */
	removeMarkers() {

		if (this.map_layers != undefined && this.map_layers.length > 0) {
			this.map_layers.forEach(l => {
				this.map.removeLayer(l);
			});
		}

		this.markers = [];
		this.map_layers = [];
	}

	/* focus on a Marker
	-------------------------------------------------------------------------------------------------- */
	focusMarker(place_id) {
		const marker = this.markers[place_id];
		const latLngs = [ marker.getLatLng() ];
		const markerBounds = L.latLngBounds(latLngs);
		this.map.fitBounds(markerBounds);
	}

	/* Place to marker
	-------------------------------------------------------------------------------------------------- */
	newMarker(place) {

		// Get place leaflet icon
		let myIcon;
		if( (place.icon in this.icons_L) ) {
			myIcon = this.icons_L[ place.icon ];
		} else {
			myIcon = this.icons_L[ 'default' ];
		}

		// create marker
		const marker = new L.marker( [ place['lat'], place['lng'] ], { icon: myIcon } );
		marker.dataset = place; // Save place data in marker object

		// Save for later use
		this.markers[ place['id'] ] = marker;

		return marker;
	}

	/* Get place icon - return a img tag
	-------------------------------------------------------------------------------------------------- */
	getPlaceIcon(place){

		if( place['icon'] in this.icons_L ) {
			return `<img class="map-icon" src="${this.icons_L[ place['icon'] ].options.iconUrl }" style="width:20px;" >`;
		} else {
			return `<img class="map-icon" src="${this.icons_L[ 'default' ].options.iconUrl }" style="width:20px;" >`;
		}

	}

	/* add a Marker
	-------------------------------------------------------------------------------------------------- */
	addMarker(place) {

		// Create a marker
		let marker = this.newMarker(place);
		marker.addTo(this.map);

		// Add to layers array
		this.map_layers.push(marker);

		// Center the map
		this.center();

		return marker;
	}

	/* add Markers
	-------------------------------------------------------------------------------------------------- */
	addMarkers(places, clickFunction) {

		//Get class context
		const $this = this;

		// Create Cluster Markers Group
		const markersCluster = L.markerClusterGroup();

		places.forEach(place => {

			// Create marker
			let marker = this.newMarker(place);

			// Create click event
			if (typeof clickFunction == 'function') {
				marker.on('click', function() {
					clickFunction(place.id);
				});
			}

			// Add to MarkersCluster
			markersCluster.addLayer(marker);

		});

		// Add Markers Cluster to the map
		this.map.addLayer(markersCluster);

		// Add to layers array
		this.map_layers.push( markersCluster );

		// Center the map
		this.center();
	}

	/* Center the map
	-------------------------------------------------------------------------------------------------- */
	center() {

		let geo_points = [];

		this.markers.forEach(m => {
			const coordinates = m.getLatLng();
			geo_points.push( [ coordinates.lat, coordinates.lng ] );
		});

		// Define map center
		const bounds = new L.LatLngBounds( geo_points );
		this.map.fitBounds(bounds, { maxZoom: 16 });

	}

}
